

export enum FilterOperator {
  None = 0,
  Contains = 1,
  GreaterThan = 2,
  GreaterThanOrEqual = 4,
  LessThan = 8,
  LessThanOrEqualTo = 16,
  StartsWith = 32,
  EndsWith = 64,
  Equals = 128,
  NotEqual = 256,
  Between = 1024,
  In = 2048,
}

export enum DefaultWhenType {
  None = 0,
  Numeric = 1,
  Text = 2,
}


export enum SortDirection {
  Ascendent,
  Descendent,
}

